import React, { useState } from "react"
import styled from "@emotion/styled"
import HamburgerIconImage from "./images/hamburger-icon-image"
import CloseIconImage from "./images/close-icon-image"
import PropTypes from "prop-types"
import { graphql, useStaticQuery } from "gatsby"
import facepaint from "facepaint"
import Media from "react-media"
import BigPanelBgImgPC from "../images/bigpanel-bg-pc.jpg"
import { Link } from "gatsby"

import NextReadersLatestMenuImage from "./images/next-readers-latest-menu-image"

const breakpoints = [576, 768, 992, 1200]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const Container = styled.div``
const HamburgerMenu = () => {
  const data = useStaticQuery(graphql`
    query HamburgerMenuQuery {
      allLeaderCsv(filter: { year: { eq: "2020" } }) {
        edges {
          node {
            id
            name
            photo
            post_title
            post_url
            title
            year
          }
        }
      }
    }
  `)
  const [menuOpen, setMenuOpen] = useState(false)

  const closeMenu = () => {
    setMenuOpen(false)
  }

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }

  const HamburgerIcon = styled.div`
    position: fixed;
    top: 18px;
    right: 18px;
    z-index: 1000;
    cursor: pointer;
  `
  const CloseIcon = styled.div`
    position: fixed;
    top: 18px;
    right: 18px;
    z-index: 1000;
    cursor: pointer;
  `
  const HamburgerMenuContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    z-index: 10001;
    ${mq({
      width: ["60%", "100%", "100%", "100%"],
    })};
    height: 100vh;
    padding: 16px;
    text-align: center;
    background-color: #000000;
    color: #ffffff;
    display: ${menuOpen === true ? "block" : "none"};
    overflow: auto;

    @media (min-width: 577px) {
      ::after {
        content: "";
        background-image: url(${BigPanelBgImgPC});
        background-size: cover;
        background-position: center;
        opacity: 0.2;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        position: fixed;
        z-index: -1;
      }
    }
  `

  const Menu = styled.div`
    ${mq({
      width: ["auto", "100%", "100%", "100%"],
    })};
    height: 100%;
    padding: 0;
    text-align: center;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    a {
      display: block;
      ${mq({
        marginTop: ["auto", "auto", "0", "0"],
        marginBottom: ["4.5vw", "4.2vw", "0", "0"],
      })};
      color: #ffffff;
      text-decoration: none;
    }

    li {
      font-weight: 400;
      text-align: center;
      text-align: -webkit-center;
    }
  `
  const MenuHeader = styled.div`
    ${mq({
      fontSize: ["4.5vw", "1.2rem", "1.2rem", "1.2rem"],
      marginBottom: ["4.5vw", "1.5rem", "1.5rem", "1.5rem"],
    })};
    color: #ffffff;
    font-weight: bold;
  `
  const Header = styled.h2`
    ${mq({
      fontSize: ["6.0vw", "2.0rem", "2.0rem", "2.0rem"],
      marginBottom: ["5.0vw", "1.5rem", "1.5rem", "1.5rem"],
    })};
    color: #e6b422;
    font-weight: bold;
  `
  const NextReadersList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    ${mq({
      marginBottom: ["7.5vw", "1.0rem", "1.0rem", "1.0rem"],
      maxWidth: ["auto", "auto", "875px", "875px"],
      flexDirection: ["column", "column", "row", "row"],
    })};
  `
  const NextReaderListItem = styled.li`
    ${mq({
      width: ["auto", "auto", "20%", "20%"],
      marginBottom: ["0", "30px", "30px", "30px"],
      flexDirection: ["column", "column", "row", "row"],
      fontSize: ["4.2vw", "0.625rem", "0.625rem", "0.625rem"],
    })};
  `
  const NextReaderListItemText = styled.span``
  const NextReaderListItemImageText = styled.div`
    width: 100px;

    img {
      border: 2px solid #c7a542 !important;
    }
    .gatsby-image-wrapper {
      ${mq({
        marginBottom: ["0", "10px", "10px", "10px"],
      })};
    }
  `
  const ArchiveList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    ${mq({
      maxWidth: ["auto", "auto", "320px", "320px"],
      flexDirection: ["column", "column", "row", "row"],
    })};
  `
  const ArchiveListItem = styled.li`
    @media (min-width: 577px) {
      :first-of-type {
        border-right: 1px solid #fff;
      }
    }
    ${mq({
      width: ["auto", "auto", "50%", "50%"],
      flexDirection: ["column", "column", "row", "row"],
      fontSize: ["5.2vw", "1.5rem", "1.5rem", "1.5rem"],
    })};
  `

  return (
    <Container>
      <HamburgerMenuContainer>
        <CloseIcon onClick={() => closeMenu()}>
          <CloseIconImage></CloseIconImage>
        </CloseIcon>
        <Menu>
          <MenuHeader>MENU</MenuHeader>
          <Header>NEXT LEADERS</Header>
          <NextReadersList>
            {data.allLeaderCsv.edges.map((leader, index) => {
              const key = `HamburgerMenuContainer-${leader.node.id}`
              const anchor_link = `anchor_${leader.node.year}_${index}`
              return (
                <Media
                  key={key}
                  queries={{
                    sp: "(max-width: 767px)",
                    pc: "(min-width: 768px)",
                  }}
                >
                  {matches => (
                    <NextReaderListItem>
                      <Link to={`/#${anchor_link}`} onClick={() => closeMenu()}>
                        {matches.pc && (
                          <NextReaderListItemImageText>
                            <NextReadersLatestMenuImage
                              fileName={leader.node.photo}
                            ></NextReadersLatestMenuImage>
                            {leader.node.name}
                          </NextReaderListItemImageText>
                        )}
                        {matches.sp && (
                          <NextReaderListItemText>
                            {leader.node.name}
                          </NextReaderListItemText>
                        )}
                      </Link>
                    </NextReaderListItem>
                  )}
                </Media>
              )
            })}
          </NextReadersList>
          <Header>ARCHIVE</Header>
          <ArchiveList>
            <ArchiveListItem>
              <Link to={`/#anchor_archive_2019`} onClick={() => closeMenu()}>
                2019
              </Link>
            </ArchiveListItem>
            <ArchiveListItem>
              <Link to={`/#anchor_archive_2018`} onClick={() => closeMenu()}>
                2018
              </Link>
            </ArchiveListItem>
          </ArchiveList>
        </Menu>
      </HamburgerMenuContainer>

      <HamburgerIcon onClick={() => toggleMenu()}>
        <HamburgerIconImage></HamburgerIconImage>
      </HamburgerIcon>
    </Container>
  )
}

HamburgerMenu.defaultProps = {
  name: "テスト",
  layout: "right",
}
HamburgerMenu.propTypes = {
  post_title: PropTypes.string,
}

export default HamburgerMenu
